import ArtistPageLoader from '@/components/loaders/ArtistLandingPageLoader';
import SEO from '@/components/seo';
import Track404 from '@/components/notFoundPages/trackNotFound';
import ArtistTemplate from '@/components/templates/ArtistTemplate';
import useGetArtist from '@/hooks/useGetArtist';
import { getArtistSeoDescription, getArtistSeoKeywords } from '@/utils/seoMeta';
import { toArtistSlug } from '@/utils/artistSlug';
import React, { useEffect, useState } from 'react';

const MAIN_ARTIST = 'Truevined';

const HomePage: React.FC = () => {
  const [artistName, setArtistName] = useState<string | null>(null);
  const [artistId, setArtistId] = useState<string | null>(null);

  useEffect(() => {
    setArtistName(MAIN_ARTIST);
    setArtistId(MAIN_ARTIST);
  }, []);

  const artistData = useGetArtist(
    {
      artistId: artistId,
    },
    null,
    [artistName]
  );

  if (!artistData) {
    return <ArtistPageLoader artistName={MAIN_ARTIST} />;
  }

  if (artistData?.error) {
    return (
      <>
        <SEO
          title={artistData.error === 'Artist not found' ? 'Artist Not Found' : 'Artist Temporarily Unavailable'}
          description="The artist page is temporarily unavailable."
        />
        <Track404
          song={{ artist: artistName || 'Truevined', artistUsername: toArtistSlug(artistName) || 'truevined' }}
          pageTitle={artistData.error === 'Artist not found' ? 'Artist Not Found' : 'Artist Temporarily Unavailable'}
          message={artistData.error === 'Artist not found' ? "doesn't exist on our platform. But hey, we love you!" : 'could not load from Spotify right now. Please try again shortly.'}
          errorType="page"
          skipArtistFetch
          temporary={artistData.error !== 'Artist not found'}
        />
      </>
    );
  }

  if (artistData && !artistData.error) {
    const loadedArtist = artistData.artistData;
    return (
      <>
        <SEO
          title={`${loadedArtist?.name || MAIN_ARTIST} Official Artist Website`}
          description={getArtistSeoDescription(loadedArtist)}
          image={loadedArtist?.images?.[0]?.url}
          url="/"
          type="music.musician"
          keywords={getArtistSeoKeywords(loadedArtist, ['official artist website'])}
          author={loadedArtist?.name || MAIN_ARTIST}
        />
        <ArtistTemplate artist={artistData} showGrain />
      </>
    );
  }

  return null;
};

export default HomePage;
